"use strict";

// https://html.spec.whatwg.org/multipage/obsolete.html#dom-external
exports.implementation = class ExternalImpl {
  // The AddSearchProvider() and IsSearchProviderInstalled() methods must do nothing
  AddSearchProvider() {}

  IsSearchProviderInstalled() {}
};
